import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebaseMessaging from '../firebase'
import { VueCookieNext } from 'vue-cookie-next'
import axios from 'axios'
import './registerServiceWorker.js'

import messaging from 'firebase/app'
import 'firebase/messaging'

// import VueMobileDetection from 'vue-mobile-detection'
// import OtpInput from "@bachdgvn/vue-otp-input";
import VueProgrammaticInvisibleGoogleRecaptcha from 'vue-programmatic-invisible-google-recaptcha'
import { createGtm } from '@gtm-support/vue-gtm'
import alertMixins from './mixins/Alert'
import helperMixins from './mixins/helper'

import 'v-calendar/dist/style.css'

axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.patch['Content-Type'] = 'application/x-www-form-urlencoded'
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  const token = store.state.token
  if (config.url.includes('member') || config.url.includes('content') || config.url.includes('notification') || config.url.includes('logout')) {
    config.headers.Authorization = `Bearer ${token}`
  }
  if (config.url.includes('auth')) {
    config.headers['X-Accept-version'] = '2.0'
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

const app = createApp(App)
// app.use(VueMobileDetection)

app.directive('numberonly', {
  updated (el, binding, vnode) {
    // eslint-disable-next-line no-useless-escape
    if (/[\d\.]+/i.test(el.value)) {
    } else {
      const newValue = el.value.replace(/[a-zA-Z]+/ig, '')
      el.value = newValue
      binding.value = el.value
    }
  }
})

if (messaging.messaging.isSupported()) {
  app.config.globalProperties.$messaging = firebaseMessaging
}

app.mixin(alertMixins)
app.mixin(helperMixins)
app.use(store)
app.component('vue-programmatic-invisible-google-recaptcha', VueProgrammaticInvisibleGoogleRecaptcha)
app.use(
  createGtm({
    id: 'GTM-P6SGNWD',
    enabled: true,
    vueRouter: router
  })
)

// store.app = app
app.use(router)
router.app = app
app.use(VueCookieNext)
app.mount('#app')
